(function() {
    'use strict';

    angular
        .module('gatewayApp')
         .service("workflowSharedService", function () {        	
        	this.viewFrom= 'gstSettings'
        })
        
        .controller('GSTSettingsController', GSTSettingsController);

    GSTSettingsController.$inject = ['$scope', '$state', 'GSTSettings', 'GlobalValues', 'workflowSharedService', 'EntityPermissions', 'ScreenLog','entityConstants','$timeout'];

    function GSTSettingsController($scope, $state, GSTSettings , GlobalValues, workflowSharedService, EntityPermissions, ScreenLog,entityConstants,$timeout) {
        var vm = this;
        vm.globalValues = GlobalValues;
        vm.entityConstants = entityConstants;
        vm.screenName = entityConstants.ENTITY_SHORT_NAME.GST_SETTINGS;
        $scope.noOfRecordsPerPage = GlobalValues.getNoOfRecordsPerPageInPagination();
        $scope.page = 1;
        vm.screenLog = ScreenLog;
        workflowSharedService.viewFrom = "gstSettings";
        $scope.refresh=refresh;
        vm.noOfDecimalsForAmount = vm.globalValues.getNumberOfDecimalsForAmount();
        vm.decimalsForPercent = vm.globalValues.getNumberOfDecimalsForPercent();
        
        vm.launch=launch;
        function launch() {
        	$state.go("gst-settings-new");
        }
        
        
        vm.permitGSTSettingsAddEntityAction = EntityPermissions.hasPermission('GSTSettings.CREATE');
        vm.permitGSTSettingsImportEntityAction = EntityPermissions.hasPermission('GSTSettings.IMPORT');
        vm.permitGSTSettingsEditEntityAction = EntityPermissions.hasPermission('GSTSettings.EDIT');
        
        logScreenAccess();
        loadAll();

       function loadAll() {
    	   
    	   GSTSettings.query(function(result) {
               vm.gstSettings = result;                
           });
    	 
        }      
       
       function logScreenAccess(){
       	ScreenLog.screenLog( vm.screenName,0, entityConstants.ENTITY_ACTION_TYPE.ACCESS);
       }
       
       $scope.toggle = true;
       function refresh() {
           $scope.toggle = false;
           $scope.refreshFlag = false;
           loadAll();
           if ($scope.toggle == false) {
               $timeout(function() {
                   $scope.toggle = true;
               }, 2000);
               $scope.refreshFlag = false;
           }
       };
    }
})();
